<template>
  <div class="tiles">
    <router-link
      :to="{ name: routerName, params: { id: item.id } }"
      class="tile"
      v-for="(item, index) in items"
      :key="index"
    >
      <h4 class="chapter" v-if="item.data && item.data.kapitel">
        {{ item.data.kapitel }}
      </h4>
      <div class="tileLayout">
        <img
          class="tile-img"
          :src="imgsrc(item, item.image)"
          v-if="item.image"
        />
        <img
          class="tile-img"
          :src="imgsrc(item, item.data.image)"
          v-else-if="item.data && item.data.image"
        />
        <div v-else-if="item.box_type == 'FAV'">
          <i class="fas fa-heart red" />
        </div>
        <DefaultImage v-else />
        <h3 class="mainTitle">
          {{ item.name }}
        </h3>
      </div>
    </router-link>
  </div>
</template>

<script>
import DefaultImage from "@/components/helpers/DefaultImage";
export default {
  name: "Tiles",
  props: {
    items: {
      type: Array,
      required: true
    },
    tileType: {
      type: String,
      default: "box"
    }
  },
  components: {
    DefaultImage
  },
  computed: {
    routerName() {
      if (this.tileType == "classroom") {
        return "classroom";
      }
      return "interim-box";
    }
  },
  methods: {
    imgsrc(box, image) {
      let baseStaticHost =
        box.box_type === "SPRKR"
          ? "https://f002.backblazeb2.com/file/initial-images"
          : "https://f002.backblazeb2.com/file/sprkr-user-uploads";
      baseStaticHost =
        process.env.NODE_ENV == "development" ? "" : baseStaticHost;
      return image ? `${baseStaticHost}/${image}` : "";
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";
.tiles {
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
}

.tile {
  display: flex;
  flex: 1 0 calc(33% - 16px);
  margin: 8px;
  height: 150px;
  border: 1px solid #e3e3e3;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  position: relative;

  h4.chapter {
    margin: 0;
    position: absolute;
    top: 5px;
    left: 5px;
    border-bottom: 5px solid #ccc;
  }

  .tileLayout {
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;

    h3.mainTitle {
      margin: 0;
      text-align: center;
    }

    i.red {
      flex: 1;
      color: $action-red;
      font-size: 3rem;
      box-shadow: rgba($color: #a0a0a0, $alpha: 0.5);
    }
  }
}
</style>
